/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  OndemandContainer,
  HeadingContainer,
  ViewAllText,
  TotalPoints,
  EventPointCard,
  NumberFont,
  EventPointsWrapper,
  CategoryCard,
  SliderContainer,
  ReservedButton,
} from "./styles";
//import { NoComments } from "../SocialFeeds/styles";
import Waiting from "../Waiting";
import { withTranslation } from "react-i18next";
import { fetchOnDemandVideosByCatgoryId } from "../../redux/actions";
//import RecommendEventVideos from "./RecommendEventVideos";
//import { NewCardContainer, NewTitle } from "./RecommendEventVideos/styles";
import { NewTitle } from "./RecommendEventVideos/styles";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import {
  getUnit,
  convertDateInTimezone, /*convertHtmlToText*/
  fetchApi,
} from "../../utils/methods";
import { BuddyTabContainer } from "../PeopleHomeV2/styles";
import { OverlayTrigger, Popover } from "react-bootstrap";
import {
  TeamCreationNotification,
  ToolTipNew,
} from "../AdminTeamCreation/styles";
import { ImageUrl } from "../../utils/constants";
import {
  Layout,
  WolibaCard,
  // MainContainer,
  Container,
  CompanyCard,
} from "./CompanyLiveEvents/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutTheEventModal from "./AboutTheEventModal";
import moment from "moment";
import AddInCalendar from "../AddInCalendar/calendarPopup";
import LazyImage from "../common/LazyImage/LazyImage";
import {
  /*arrowIconDouble*/ NewBackArrowIconEventPage,
  NewNextArrowIconEventPage,
  NewScheduledEventIcon,
  DatePickerIconUserEvents,
  PeopleIconForRegisteredUsers,
  CompanyWolibaUserEventsIcon,
  UserEventCatogoriesIcon,
  AboutEventIcon,
  StarIcon,
  // StarIcon,
  
} from "../../utils/icons";
import { BuddyTab, CommonButtonBorder } from "../common/commonStyles";
import { CoachCard } from "./SingleEventV2/styles";
import parse from "react-html-parser";
import { LearningGrowthIcon, CommunityGivingIcon, HeartHealthIcon, DEIIcon, MentalWellbeingIcon, NutritionIcon, SelfImprovementIcon, EngagementCultureIcon, StressIcon, StressManagementIcon, WeightLossIcon, BenefitsIcon } from '../../utils/icons'
import RecommendedEvents from "../CompanyEvents/RecommendedEvents";
import { Heading } from "../RecogntionAdmin/styles";
import { GetRecommendedEventData, JoinOrLeaveThemeEvent } from "../../redux/constants/apiConstants";
import Timer from "../EventDetails/timer";
import { toast } from "react-toastify";
import Spinner from "../common/Spinner";

const categoryIconMap = {
  "Health": MentalWellbeingIcon,
  "Nutrition": NutritionIcon,
  "Workplace Wellness": BenefitsIcon,
  "Fitness": LearningGrowthIcon,
  "Lifestyle": DEIIcon,
  "Mental Health": StressIcon,
  "Stress Management": StressManagementIcon,
  "Healthy Habits": CommunityGivingIcon,
  "Heart Health": HeartHealthIcon,
  "Self-Improvement": SelfImprovementIcon,
  "Social Wellbeing": EngagementCultureIcon,
  "Weight Loss": WeightLossIcon,
};


const categoryColorMap = {
  Health: "#FCF2F3",
  Nutrition: "#F1F8F2",
  "Workplace Wellness": "#F2F5FB",
  Fitness: "#FCF7F0",
  Lifestyle: "#F5F6E8",
  "Mental Health": "#FAF5F8",
  "Stress Management": "#FCF7F0",
  "Healthy Habits": "#F1F8F2",
  "Heart Health": "#FCF2F3",
  "Self-Improvement": "#F5F6E8",
  "Social Wellbeing": "#FBF4F9",
  "Weight Loss": "#F2F5FB",
};


const NextArrow = ({ currentSlide, slideCount, onClick }) => {
  const isLastSlide = currentSlide === slideCount - 1;
  if (isLastSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-next"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

NextArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

// Custom Prev Arrow Component with PropTypes
const PrevArrow = ({ currentSlide, onClick }) => {
  const isFirstSlide = currentSlide === 0;
  if (isFirstSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-prev"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

PrevArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

class MainEvents extends Component {
  constructor() {
    super();
    this.sliderRef = React.createRef();
    this.state = {
      pageNumber: 1,
      tab: 1,
      activeStatus: true,
      onHover: -1,
      eventCreate: false,
      ondemandCreate: false,
      selectedCategoryId: 1,
      selectedCategoryName: "Fitness",
      hoverCategoryId: null,
      showAboutEventModal: false,
      showCalendar: false,
      eventId: null,
      eventCalendarId: null,
      timeout: false,
      eventName: null,
      isButtonDisabled: false,
      scheduledEvents: false,
      currentSlide: 1,
      eventData:[],
      recommendedEventDataLoading:false,
      loadingJoinThemeEvent:false
      
    };
  }

  GetRecommendedEvents = async () => {
    const {user,companyInfo} = this.props;
    let companyId = user?.company_id ? user?.company_id : companyInfo?.id;
    window.console.log("error", user)
    // const apiUrl = `${GetRecommendedEventData}+"/" + ${companyId}`;
    let apiUrl = GetRecommendedEventData + "/" + companyId;
    this.setState({ recommendedEventDataLoading: true });

    try {
      const res = await fetchApi(apiUrl, "GET");
      window.console.log("reserror", res)
      if (res.status === "success") {
        this.setState({
          eventData: res?.data,
          recommendedEventDataLoading: false,
        });
      } else {
        toast.error(res.error);
        this.setState({ recommendedEventDataLoading: false });
      }
    } catch (error) {
      this.setState({ recommendedEventDataLoading: false });
      console.error(error);
    }
  };

  componentDidMount() {
    const {
      fetchOnDemandVideosByCatgoryId,
      fetchEvents,
      fetchWolibaEvents,
      fetchCompanyEvents,
      history,

    } = this.props;
    const { selectedCategoryId } = this.state;
    fetchOnDemandVideosByCatgoryId(selectedCategoryId);

    if (history.location.state === "updateData") {
      fetchEvents(1);
      fetchWolibaEvents();
      fetchCompanyEvents();
    }
   
    this.GetRecommendedEvents();
  
  }

  componentDidUpdate() {
    this.state.timeout &&
      window.setTimeout(() => {
        this.setState({ timeout: false });
      }, 5000);
  }

  

  calendarConfirmPopup = () => {
    this.setState({
      timeout: true,
    });
  };

  showArticle = (id) => {
    const { history, location } = this.props;
    const currentLocation = location.pathname;
    const stringArray = location.pathname.split("/");
    let url = stringArray[2] === "videos-library" ? "fitness" : "article";
    history.push(`${currentLocation}/${url}/${id}`);
  };

  onScroll = (e, events) => {
    const { pageNumber } = this.state;
    const { loadMoreEvents, totalCount } = this.props;
    const bottom =
      Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop, 10)) ===
      Math.round(e.target.clientHeight);
    if (events.length < totalCount) {
      if (bottom) {
        this.setState(
          {
            pageNumber: pageNumber + 1,
          },
          () => {
            loadMoreEvents(this.state.pageNumber);
          }
        );
      }
    }
  };

  onEnterMouse = (id) => {
    this.setState({
      onHover: id,
    });
  };

  onLeaveMouse = () => {
    this.setState({
      onHover: -1,
    });
  };

  updateSelectedCategoryId = (id, name) => {
    const { fetchOnDemandVideosByCatgoryId } = this.props;
    this.setState(
      {
        selectedCategoryId: id,
        selectedCategoryName: name,
      },
      () => {
        fetchOnDemandVideosByCatgoryId(id);
      }
    );
  };

  getTotalPoints = () => {
    const { t, eventsDetailsPoints } = this.props;
    return (
      <TotalPoints>
        <LazyImage src={ImageUrl + "/images/events_main.png"} />
        <div>
          <div>{t("Total Points Earned")}</div>
          <div>
            {!isUndefined(eventsDetailsPoints)
              ? getUnit(eventsDetailsPoints["total_points"])
              : "0"}
          </div>
        </div>
      </TotalPoints>
    );
  };

  getEventDetails = () => {
    const { t, eventsDetailsPoints } = this.props;
    const eventsPointsDetailsData = [
      {
        name: "Live Events Points",
        count: `${!isUndefined(eventsDetailsPoints)}`
          ? `${eventsDetailsPoints["event_points"]}`
          : 0,
        image: "/images/events_new_live.png",
      },
      {
        name: "On-Demand Events Points",
        count: `${!isUndefined(eventsDetailsPoints)}`
          ? `${eventsDetailsPoints["on_demand_event_points"]}`
          : 0,
        image: "/images/events_demand.png",
      },
      {
        name: "Live Events Participated",
        count: `${!isUndefined(eventsDetailsPoints)}`
          ? `${eventsDetailsPoints["event_count"]}`
          : 0,
        image: "/images/events_participated.png",
      },
      {
        name: "On-Demand Events Watched",
        count: `${!isUndefined(eventsDetailsPoints)}`
          ? `${eventsDetailsPoints["on_demand_event_count"]}`
          : 0,
        image: "/images/events_watched_neww.png",
      },
    ];
    return eventsPointsDetailsData.map((data, index) => (
      <EventPointCard key={index}>
        <div className="card">
          <div className="flex">
            <LazyImage
              div={"block"}
              src={ImageUrl + data.image}
              alt="completed icon"
            />
            <div className="text">{t(data.name)}</div>
            <NumberFont>{getUnit(Math.round(data["count"]))}</NumberFont>
          </div>
        </div>
      </EventPointCard>
    ));
  };

  showPastEvents = () => {
    this.props.history.push(`/events/completed`);
  };

  eventButtonStatusHover = (value) => {
    if (value === "event")
      this.setState({
        eventCreate: true,
      });
    else if (value == "schedule") {
      this.setState({
        scheduledEvents: true,
      });
    } else {
      this.setState({
        ondemandCreate: true,
      });
    }
  };

  eventButtonStatus = (value) => {
    if (value === "event")
      this.setState({
        eventCreate: false,
      });
    else if (value == "schedule") {
      this.setState({
        scheduledEvents: false,
      });
    } else {
      this.setState({
        ondemandCreate: false,
      });
    }
  };

  categoryStatusHover = (value) => {
    this.setState({
      hoverCategoryId: value,
    });
  };

  categoryStatusRemoveHover = () => {
    this.setState({
      hoverCategoryId: null,
    });
  };

  schedule = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69065 11.6821C8.69065 11.894 8.50521 12.0795 8.29329 12.0795H6.80985C6.59793 12.0795 6.4125 11.894 6.4125 11.6821V10.1987C6.4125 9.98675 6.59793 9.80132 6.80985 9.80132H8.29329C8.50521 9.80132 8.69065 9.98675 8.69065 10.1987V11.6821ZM11.8165 10.1987C11.8165 9.98675 11.631 9.80132 11.4191 9.80132H9.93568C9.72376 9.80132 9.53833 9.98675 9.53833 10.1987V11.6821C9.53833 11.894 9.72376 12.0795 9.93568 12.0795H11.4191C11.631 12.0795 11.8165 11.894 11.8165 11.6821V10.1987ZM14.9423 10.1987C14.9423 9.98675 14.7569 9.80132 14.545 9.80132H13.035C12.8231 9.80132 12.6377 9.98675 12.6377 10.1987V11.6821C12.6377 11.894 12.8231 12.0795 13.035 12.0795H14.5185C14.7304 12.0795 14.9158 11.894 14.9158 11.6821V10.1987H14.9423ZM8.69065 13.2185C8.69065 13.0066 8.50521 12.8212 8.29329 12.8212H6.80985C6.59793 12.8212 6.4125 13.0066 6.4125 13.2185V14.702C6.4125 14.9139 6.59793 15.0993 6.80985 15.0993H8.29329C8.50521 15.0993 8.69065 14.9139 8.69065 14.702V13.2185ZM11.8165 13.2185C11.8165 13.0066 11.631 12.8212 11.4191 12.8212H9.93568C9.72376 12.8212 9.53833 13.0066 9.53833 13.2185V14.702C9.53833 14.9139 9.72376 15.0993 9.93568 15.0993H11.4191C11.631 15.0993 11.8165 14.9139 11.8165 14.702V13.2185ZM14.545 12.8212H13.035C12.8231 12.8212 12.6377 13.0066 12.6377 13.2185V14.702C12.6377 14.9139 12.8231 15.0993 13.035 15.0993H14.5185C14.7304 15.0993 14.9158 14.9139 14.9158 14.702V13.2185C14.9423 13.0066 14.7569 12.8212 14.545 12.8212ZM5.16747 15.8675H3.68402C3.4721 15.8675 3.28667 16.053 3.28667 16.2649V17.7483C3.28667 17.9603 3.4721 18.1457 3.68402 18.1457H5.16747C5.37939 18.1457 5.56482 17.9603 5.56482 17.7483V16.2649C5.56482 16.053 5.40588 15.8675 5.16747 15.8675ZM5.56482 13.2185C5.56482 13.0066 5.37939 12.8212 5.16747 12.8212H3.68402C3.4721 12.8212 3.28667 13.0066 3.28667 13.2185V14.702C3.28667 14.9139 3.4721 15.0993 3.68402 15.0993H5.16747C5.37939 15.0993 5.56482 14.9139 5.56482 14.702V13.2185ZM11.4191 15.8675H9.93568C9.72376 15.8675 9.53833 16.053 9.53833 16.2649V17.7483C9.53833 17.9603 9.72376 18.1457 9.93568 18.1457H11.4191C11.631 18.1457 11.8165 17.9603 11.8165 17.7483V16.2649C11.8165 16.053 11.631 15.8675 11.4191 15.8675ZM8.29329 15.8675H6.80985C6.59793 15.8675 6.4125 16.053 6.4125 16.2649V17.7483C6.4125 17.9603 6.59793 18.1457 6.80985 18.1457H8.29329C8.50521 18.1457 8.69065 17.9603 8.69065 17.7483V16.2649C8.69065 16.053 8.50521 15.8675 8.29329 15.8675ZM17.6443 12.0795C17.8562 12.0795 18.0416 11.894 18.0416 11.6821V10.1987C18.0416 9.98675 17.8562 9.80132 17.6443 9.80132H16.1608C15.9489 9.80132 15.7635 9.98675 15.7635 10.1987V11.6821C15.7635 11.894 15.9489 12.0795 16.1608 12.0795H17.6443ZM2.30654 21.404H13.6443C13.4589 20.8212 13.3529 20.2119 13.3529 19.6026H2.30654C2.01515 19.6026 1.77674 19.3642 1.77674 19.0728V8.39735H19.5516V13.3775C20.1873 13.3775 20.7966 13.4834 21.3529 13.6424V4.63576C21.3529 3.33775 20.2933 2.30464 19.0218 2.30464H16.3993V0.847682C16.3993 0.370861 16.0284 0 15.5516 0H14.2271C13.7502 0 13.3794 0.370861 13.3794 0.847682V2.30464H7.97541V0.847682C7.97541 0.370861 7.60455 0 7.12773 0H5.80323C5.32641 0 4.95555 0.370861 4.95555 0.847682V2.30464H2.33303C1.03502 2.30464 0.00190412 3.36424 0.00190412 4.63576V19.0464C-0.051076 20.3444 1.00853 21.404 2.30654 21.404ZM24.0019 19.5232C24.0019 21.9868 21.9887 24 19.5251 24C17.0615 24 15.0483 21.9868 15.0483 19.5232C15.0483 17.0596 17.0615 15.0464 19.5251 15.0464C21.9887 15.0464 24.0019 17.0596 24.0019 19.5232ZM21.7767 18.3576C21.7767 18.2252 21.7238 18.0662 21.6178 17.9868C21.4059 17.7748 21.0615 17.7748 20.8496 17.9868L18.9158 19.9205L18.1741 19.1788C17.9622 18.9669 17.6178 18.9669 17.4059 19.1788C17.2999 19.2848 17.2469 19.4172 17.2469 19.5497C17.2469 19.6821 17.2999 19.8146 17.4059 19.9205L18.5185 21.0331C18.7304 21.245 19.0748 21.245 19.2867 21.0331L21.6178 18.702C21.7238 18.649 21.7767 18.5166 21.7767 18.3576Z"
        fill="#9C9C9C"
      />
    </svg>
  );

  redirect = () => {
    this.props.history.push(`/events/schedule`);
  };

  headerView = () => {
    //const { /*eventCreate, ondemandCreate,*/ scheduledEvents } = this.state;
    // const { role, isAdmin } = this.props;
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {value}
        </div>
      </Popover>
    );
    return (
      <BuddyTabContainer
        marginBottom="20px"
        style={{ justifyContent: "space-between" }}
        pLeft="0px"
      >
        <div style={{ display: "flex", gap: "12px" }}>
          <BuddyTab active padding customBg="#F37A65">
            {this.props.t("Events")}
          </BuddyTab>
          <BuddyTab padding onClick={() => this.showPastEvents()}>
            {" "}
            {this.props.t("Completed")}
          </BuddyTab>
        </div>
        <div style={{ display: "flex" }}>
          <ToolTipNew
            width="40px"
            height="40px"
            margin={"auto 8px auto auto"}
            transparent
            // active={scheduledEvents}
            // onMouseEnter={() => this.eventButtonStatusHover("schedule")}
            // onMouseLeave={() => this.eventButtonStatus("schedule")}
          >
            <OverlayTrigger
              placement="bottom"
              overlay={popover(this.props.t("Scheduled Events"))}
            >
              <div className='="toolTip' onClick={this.redirect}>
                {/* {
                  <StyledSvgNew active={scheduledEvents} isCompletedEvents={true} width="24px" >
                    {NewScheduledEventIcon()}
                  </StyledSvgNew>
                } */}
                <div>{NewScheduledEventIcon()}</div>
              </div>
            </OverlayTrigger>
          </ToolTipNew>
          {/* {role === "ADMIN" && (
            <ToolTipNew
              margin={"auto 16px auto 8px"}
              width="40px"
              height="40px"
              active={eventCreate}
              onMouseEnter={() => this.eventButtonStatusHover("event")}
              onMouseLeave={() => this.eventButtonStatus("event")}
            >
              <OverlayTrigger
                placement="bottom"
                overlay={popover(this.props.t("Create On-Demand Event"))}
              >
                <div
                  className='="toolTip'
                  onClick={() =>
                    this.props.history.push(`/events/create-ondemand`)
                  }
                >
                  {
                    <StyledSvgNew active={eventCreate} width="24px" height="24px">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path d="M23.5334 6.05056C23.245 5.89117 22.9193 5.81173 22.59 5.82045C22.2607 5.82916 21.9397 5.92572 21.6602 6.10014L18.0228 8.37267V6.46161C18.022 5.72741 17.73 5.02351 17.2109 4.50436C16.6917 3.9852 15.9878 3.69318 15.2536 3.69238H3.25361C2.51941 3.69318 1.81551 3.9852 1.29635 4.50436C0.777191 5.02351 0.485176 5.72741 0.484375 6.46161V17.5385C0.485176 18.2727 0.777191 18.9766 1.29635 19.4958C1.81551 20.015 2.51941 20.307 3.25361 20.3078H15.2536C15.9878 20.307 16.6917 20.015 17.2109 19.4958C17.73 18.9766 18.022 18.2727 18.0228 17.5385V15.6275L21.6602 17.9C21.9396 18.0748 22.2607 18.1715 22.5902 18.1802C22.9197 18.1889 23.2455 18.1092 23.5337 17.9494C23.822 17.7896 24.0621 17.5555 24.2293 17.2715C24.3965 16.9874 24.4846 16.6638 24.4844 16.3342V7.66594C24.4843 7.33634 24.3961 7.01275 24.2289 6.72872C24.0617 6.44468 23.8215 6.21054 23.5334 6.05056Z" fill="#007AB1"/>
                        <path d="M9.40137 8.5L9.40137 15.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M5.90137 12L12.9014 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </StyledSvgNew>
                  }
                </div>
              </OverlayTrigger>
            </ToolTipNew>
          )}
          {isAdmin && (
            <ToolTipNew
              margin={role === "ADMIN" ? "auto 8px auto 0" : "auto 8px auto 8px"}
              width="40px"
              height="40px"
              active={ondemandCreate}
              onMouseEnter={() => this.eventButtonStatusHover("ondemand")}
              onMouseLeave={() => this.eventButtonStatus("ondemand")}
            >
              <OverlayTrigger
                placement="bottom"
                overlay={popover(this.props.t("Create Event"))}
              >
                <div
                  className='="toolTip'
                  onClick={() => this.props.history.push(`/company/events/create`)}
                >
                  <StyledSvgNew active={ondemandCreate}  width="24px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path d="M21.0753 2.18182H19.0298V1.09091C19.0298 0.801582 18.9149 0.524105 18.7103 0.31952C18.5057 0.114935 18.2282 0 17.9389 0C17.6496 0 17.3721 0.114935 17.1675 0.31952C16.9629 0.524105 16.848 0.801582 16.848 1.09091V2.18182H13.5753V1.09091C13.5753 0.801582 13.4603 0.524105 13.2558 0.31952C13.0512 0.114935 12.7737 0 12.4844 0C12.195 0 11.9176 0.114935 11.713 0.31952C11.5084 0.524105 11.3935 0.801582 11.3935 1.09091V2.18182H8.12074V1.09091C8.12074 0.801582 8.0058 0.524105 7.80122 0.31952C7.59663 0.114935 7.31916 0 7.02983 0C6.7405 0 6.46303 0.114935 6.25844 0.31952C6.05386 0.524105 5.93892 0.801582 5.93892 1.09091V2.18182H3.89347C2.98967 2.18297 2.12323 2.54251 1.48415 3.18159C0.845071 3.82067 0.48553 4.68712 0.484375 5.59091V8.72727H24.4844V5.59091C24.4832 4.68712 24.1237 3.82067 23.4846 3.18159C22.8455 2.54251 21.9791 2.18297 21.0753 2.18182Z" fill="#007AB1"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M0.484375 20.591C0.48553 21.4948 0.845071 22.3612 1.48415 23.0003C2.12323 23.6394 2.98967 23.9989 3.89347 24.0001H21.0753C21.9791 23.9989 22.8455 23.6394 23.4846 23.0003C24.1237 22.3612 24.4832 21.4948 24.4844 20.591V10.9092H0.484375V20.591ZM12.4844 12.9547C13.0367 12.9547 13.4844 13.4024 13.4844 13.9547V16.4547H15.9844C16.5367 16.4547 16.9844 16.9024 16.9844 17.4547C16.9844 18.0069 16.5367 18.4547 15.9844 18.4547H13.4844V20.9547C13.4844 21.5069 13.0367 21.9547 12.4844 21.9547C11.9321 21.9547 11.4844 21.5069 11.4844 20.9547V18.4547H8.98438C8.43209 18.4547 7.98438 18.0069 7.98438 17.4547C7.98438 16.9024 8.43209 16.4547 8.98438 16.4547H11.4844V13.9547C11.4844 13.4024 11.9321 12.9547 12.4844 12.9547Z" fill="#007AB1"/>
                    </svg>
                  </StyledSvgNew>
                </div>
              </OverlayTrigger>
            </ToolTipNew>
          )} */}
        </div>
      </BuddyTabContainer>
    );
  };

  categoriesCard = [
    {
      name: "Health",
      background: "rgba(253, 113, 117, 1)",
      color: "rgba(159, 201, 137, .15)",
      icon: "/images/AdminReports/Health.png",
      image: "/images/AdminReports/Health_white.png",
      id: 1,
    },
    {
      name: "Nutrition",
      background: "rgba(159, 201, 137, 1)",
      color: "rgba(159, 201, 137, .15)",
      icon: "/images/AdminReports/Nutrition.png",
      image: "/images/AdminReports/Nutrition_white.png",
      id: 4,
    },
    {
      name: "Workplace Wellness",
      background: "rgba(246, 180, 121, 1)",
      color: "rgba(246, 180, 121, .15)",
      icon: "/images/AdminReports/workplace.png",
      image: "/images/AdminReports/workplace_wellness_white.png",
      id: 6,
    },
    {
      name: "Physical Wellness",
      background: "rgba(105, 194, 255, 1)",
      color: "rgba(105, 194, 255, .15)",
      icon: "/images/AdminReports/fitness.png",
      image: "/images/AdminReports/physical_activity.png",
      id: 3,
    },
    {
      name: "Lifestyle",
      background: "rgba(157, 135, 169, 1)",
      color: "rgba(157, 135, 169, .15)",
      icon: "/images/AdminReports/lifestyle.png",
      image: "/images/AdminReports/lifestyle_white.png",
      id: 2,
    },
    {
      name: "Emotional Wellness",
      background: "rgba(255, 153, 134, 1)",
      color: "rgba(255, 153, 134, .15)",
      icon: "/images/AdminReports/emotional_wellness.png",
      image: "/images/AdminReports/emotional_wellness_white.png",
      id: 5,
    },
  ];

  toggleModal = (id, event) => {
    event.stopPropagation();
    this.setState((prev) => ({
      showAboutEventModal: !prev.showAboutEventModal,
      eventCalendarId: id,
    }));
  };

  toggleModalV2 = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState((prev) => ({
      showAboutEventModal: !prev.showAboutEventModal,
    }));
  };

  removeHtmlTags = (str) => str.replace(/<[^>]*>/g, "");

  showCalendarData = (id) => {
    this.setState((prev) => ({
      showCalendar: !prev.showCalendar,
      eventId: id,
    }));
  };

  showCalendar = (id, title, event) => {
    event.stopPropagation();
    this.setState((prev) => ({
      showCalendar: !prev.showCalendar,
      eventId: id,
      eventName: title,
    }));
  };

  showHideCalendarLogic = () => {
    this.setState((prev) => ({
      showCalendar: !prev.showCalendar,
    }));
  };

  showCalendarAndReserve = (id, isAttending, title, event) => {
    event.stopPropagation();
    if (isAttending !== 1) {
      this.setState((prev) => ({
        showCalendar: !prev.showCalendar,
      }));
    }
    this.setState(
      () => ({ eventId: id, eventName: title, isButtonDisabled: true }),
      () => {
        this.props.attendEventLimitUser(
          id,
          isAttending,
          this.showHideCalendarLogic
        );
      }
    );
    window.setTimeout(() => {
      this.setState({ isButtonDisabled: false });
    }, 2000);
  };

  hideCalendarAndReserve = (event) => {
    event.stopPropagation();
  };

  hideCalendar = (id) => {
    this.setState(
      (prev) => ({ showCalendar: !prev.showCalendar, eventId: id }),
      () => { 
        this.props.attendEvent(id, 0, 1);
        this.calendarConfirmPopup();
      }
    ); 
  };

  handleReserveSpot = (event) => {
    event.stopPropagation();
  };

  handleWolibaLive = (id, isAttending, event) => {
    event.stopPropagation();
    if (isAttending !== 1) {
      this.setState((prev) => ({
        showCalendar: !prev.showCalendar,
      }));
    }
    this.setState(
      () => ({ eventId: id, isButtonDisabled: true }),
      () => {
        this.props.attendEvent(id, isAttending);
      }
    );
    window.setTimeout(() => {
      this.setState({ isButtonDisabled: false });
    }, 2000);
  };

  redirection = () => {
    this.props.history.push("/events/live");
  };

  sortDataByDate = (data) => {
    const sortedData = data.sort(
      (a, b) => new Date(a.start_date) - new Date(b.start_date)
    );

    return sortedData;
  };

  convertMonthFromDate = (dateString) => {
    let temp = dateString.split(" ");
    temp[0] = this.props.t(temp[0]);
    temp = temp.join(" ");
    return temp;
  };

  handleBeforeChange = (oldIndex, newIndex) => {
    // Update the current slide index when the slider changes
    this.setState({ currentSlide: newIndex + 1 });
  };

  joinEvent = async(eventId,event)=>{
    event.stopPropagation();
    this.setState({loadingJoinThemeEvent:true})
    const {fetchCompanyEvents} = this.props;
    const payload = {event_id:eventId,join_status:1}
    try{
      const res = await fetchApi(JoinOrLeaveThemeEvent, "POST",payload);
      if(res.status === "success"){
        // setWellnessChallengeList(res.data);
        toast.success(res?.message);
        fetchCompanyEvents();
        // getEventDetailsById(event.id)
      }else{
        toast.error(res?.data?.message);
      }
    }catch(error){
      toast.error(error)
    }finally{
      this.setState({loadingJoinThemeEvent:false})
    }
  }

  
  render() {
    const {
      //history,
      eventResults,
      t,
      //link,
      ondemandCategory,
      //ondemandByIdData,
      wolibaEvents,
      companyEvents,
    } = this.props;
    
    const {
      activeStatus,
      //onHover,
      //selectedCategoryId,
      //hoverCategoryId,
      showAboutEventModal,
      showCalendar,
      eventId,
      eventCalendarId,
      timeout,
      eventName,
      isButtonDisabled,
      loadingJoinThemeEvent
    } = this.state;
    if (
      !eventResults ||
      isUndefined(ondemandCategory) ||
      isNull(ondemandCategory)
    ) {
      return <Waiting />;
    }
    let wolibaLiveEvents =
      wolibaEvents && wolibaEvents.length
        ? this.sortDataByDate(wolibaEvents)
        : [];
    let companyLiveEvents =
      companyEvents && companyEvents.length
        ? this.sortDataByDate(companyEvents)
        : [];
    //const lang = localStorage.getItem("lang");

    // let companyLive = {
    //   dots: false,
    //   infinite: true,
    //   speed: 300,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   draggable: true,
    //   adaptiveHeight: true,
    //   nextArrow: <div className={"left-arrow slick-next"} />,
    //   prevArrow: <div className={"left-arrow slick-prev"} />,
    //   beforeChange: this.handleBeforeChange,
    //   responsive: [
    //     {
    //       breakpoint: 1252,
    //       settings: {
    //         dots: true,
    //         infinite: true,
    //         speed: 500,
    //         draggable: false,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: true,
    //       },
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         dots: true,
    //         infinite: true,
    //         speed: 500,
    //         draggable: false,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: true,
    //       },
    //     },
    //   ],
    // };


    const companyLive = {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      draggable: true,
      adaptiveHeight: true,
      nextArrow: <NextArrow currentSlide={this.state.currentSlide} slideCount={companyLiveEvents?.length} />,
      prevArrow: <PrevArrow currentSlide={this.state.currentSlide} />,
      beforeChange: this.handleBeforeChange,
      responsive: [
        {
          breakpoint: 1252,
          settings: {
            dots: true,
            infinite: false,
            speed: 500,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <NextArrow currentSlide={this.state.currentSlide} slideCount={companyLiveEvents?.length} />,
            prevArrow: <PrevArrow currentSlide={this.state.currentSlide} />,
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            infinite: false,
            speed: 500,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <NextArrow currentSlide={this.state.currentSlide} slideCount={companyLiveEvents.length} />,
            prevArrow: <PrevArrow currentSlide={this.state.currentSlide} />,
          },
        },
      ],
    };
    return (
      <div>
        {activeStatus ? (
          <OndemandContainer>
            <div>
              {timeout && (
                <TeamCreationNotification>
                  <div className="card-style">
                    <div className="icon">
                      <img
                        src={ImageUrl + "/images/Events/whiteTick.png"}
                        alt="arrow"
                      />
                    </div>
                    <div className="notification">
                      <div className="buttonName">{eventName}</div>
                      <div className="success">{t("Added Sucessfully")}</div>
                    </div>
                  </div>
                </TeamCreationNotification>
              )}
              {this.headerView()}
              {companyLiveEvents && companyLiveEvents.length === 0 ? null : (
                <Layout  style={{background:'#fff', border:'0.75px solid #DCDCDC'}} margin={"20px 0 20px 0"} padding={"20px 20px 30px 20px"} background={'#fff'}>
                  <div className="headingMain">
                    <div style={{ gap: "12px" }} className="heading">
                      <CompanyWolibaUserEventsIcon />

                      {this.props.t("Company Events")}
                    </div>
                    {companyLiveEvents.length > 1 ? (
                      <div className="arrows">
                        <div
                          className="iconBackground"
                          // onClick={() => sliderRef?.slickPrev()}
                          style={{ 
                            opacity: this.state.currentSlide === 1 ? 0 : 1,
                            cursor: this.state.currentSlide === 1 ? 'not-allowed' : 'pointer'
                          }}
                          onClick={() => this.sliderRef.current?.slickPrev()}
                        >
                          {NewBackArrowIconEventPage()}
                        </div>
                        <div className="text">
                          {this.state.currentSlide} /{" "}
                          {companyLiveEvents?.length}
                        </div>
                        <div
                          className="iconBackground"
                          onClick={() => this.state.currentSlide < companyLiveEvents?.length && this.sliderRef.current?.slickNext()}
                          style={{ 
                            opacity: this.state.currentSlide === companyLiveEvents?.length ? 0 : 1,
                            cursor: this.state.currentSlide === companyLiveEvents?.length ? 'not-allowed' : 'pointer'
                          }}
                          // onClick={() => this.slider.slickNext()}
                        >
                          {NewNextArrowIconEventPage()}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <Container>
                    {companyLiveEvents?.length > 0 && (
                      <SliderContainer
                        display="flex"
                        content="center"
                        shadow="0px 8px 25px 0px #0D427040"
                      >
                        <Slider
                          {...companyLive}
                          ref={this.sliderRef}
                          // ref={(slider) => (this.slider = slider)}
                        >
                          {companyLiveEvents?.length > 0 &&
                            companyLiveEvents.map((data, index) => (
                              <div className="card featCard" key={index} style={{paddingRight:'0', marginRight:'-30px !important'}}>
                                <CompanyCard
                                  className="featChallanges" 
                                  detailsCardPadding="0 0 10px 20px"
                                  width="1248px"
                                  onClick={() =>
                                    this.props.history.push(
                                      `/events/${data.id}`
                                    )
                                  }
                                >
                                  <LazyImage
                                    div={"imageCard featImg"} style={{borderRadius:'8px 0  0 8px'}}
                                    src={`${ImageUrl}/${data.image}`}
                                    alt="category"
                                  />
                                  <div className="detailsCard" style={{border:'0.75px solid #DCDCDC',padding:'0 20px 20px 20px',borderRadius:'0 8px 8px 0',borderLeft:'0'}}>
                                    <div className="title">{data.title}</div>
                                    <div className="details" style={{paddingTop:'20px'}}>
                                      {parse(data.body)}
                                    </div>
                                    <div className="date">
                                      <div className="iconV1">
                                        {/* <img src={ImageUrl+"/event-section/calendarColor.svg"}/> */}
                                        <DatePickerIconUserEvents />
                                      </div>
                                      <div className="detail">
                                        {this.convertMonthFromDate(
                                          moment(
                                            convertDateInTimezone(
                                              data?.start_date
                                            )._d
                                          ).format("MMM D, YYYY | hh:mm A")
                                        )}
                                        {!data.is_all_day_event &&
                                          ` IST - ${moment(
                                            convertDateInTimezone(
                                              data?.end_date
                                            )._d
                                          ).format(
                                            "MMM D, YYYY | hh:mm A"
                                          )} IST`}
                                      </div>
                                    </div>
                                    {data?.attendees_list?.length > 0 && data.event_type != "theme" ? (
                                      <div className="date">
                                        <div className="icon">
                                          {/* <img src={ImageUrl+"/event-section/people.png"}/> */}
                                          <PeopleIconForRegisteredUsers />
                                        </div>
                                        <div className="detail">
                                          {data?.attendees_list?.length}{" "}
                                          {t("Registered")}{" "}
                                          {data?.attendees_list?.length > 1
                                            ? t("Users")
                                            : t("User")}
                                        </div>
                                      </div>
                                    ) : null}

                                    {data?.event_participants_count > 0 && data.event_type === "theme" ? (
                                      <div className="date">
                                        <div className="icon">
                                          {/* <img src={ImageUrl+"/event-section/people.png"}/> */}
                                          <PeopleIconForRegisteredUsers />
                                        </div>
                                        <div className="detail">
                                          {data?.event_participants_count}{" "}
                                          {t("joined")}{" "}
                                          {data?.event_participants_count > 1
                                            ? t("users")
                                            : t("user")}
                                        </div>
                                      </div>
                                    ) : null}

                                    {data.event_type === "theme"  ?                                            
                                      moment(convertDateInTimezone(data.start_date)._d) < new Date() && !data?.event_join_status  ?
                                        <ReservedButton active={true} height="40px" width="436px"  style={{marginTop:"auto"}}
                                          // disabled={ }
                                          onClick={(event)=>{!loadingJoinThemeEvent && this.joinEvent(data.id,event);event.stopPropagation();}} >
                                          {loadingJoinThemeEvent ? <Spinner color={'white'}/> : 'Join Event'}
                                        </ReservedButton>  : moment(convertDateInTimezone(data.start_date)._d) > new Date() ? <Timer  isBackgroundColor={"#FCF2F3"} data={moment(convertDateInTimezone(data?.start_date)._d)}/> : <CommonButtonBorder onClick={()=> this.props.history.push(`/events/${data.id}`)}  height={'40px'}width={'436px'} margin={'auto 0 0 0'}>View Event </CommonButtonBorder>  : null }
                                    {/* <ReservedButton active={true} width="436px" height={"40px"}>
                                          {("Join Event")}
                                        </ReservedButton> */}
                                       
                                    {(data.is_lunch_and_learn_event === 1 &&
                                    data.event_link) ||  data.event_type === "theme" ? null : (
                                      // <div className="buttonContainer">
                                      //   {data.is_attending === 1  && (
                                      //     <ReservedButton
                                      //       active={1}
                                      //       onClick={(event) =>
                                      //         this.showCalendar(
                                      //           data.id,
                                      //           data.title,
                                      //           event
                                      //         )
                                      //       }
                                      //     >
                                      //       {/* <div className="icon"><img src={ImageUrl + "/event-section/calendarWhite.svg"} /></div> */}
                                      //       {t("Add to Calendar")}
                                      //     </ReservedButton>
                                      //   )} 
                                          

                                        //   <ReservedButton
                                        //     width={
                                        //       !data.is_attending
                                        //         ? "436px"
                                        //         : undefined
                                        //     }
                                        //     active={!data.is_attending}
                                        //     onClick={
                                        //       isButtonDisabled
                                        //         ? null
                                        //         : (event) =>
                                        //           this.showCalendarAndReserve(
                                        //             data.id,
                                        //             data.is_attending,
                                        //             data.title,
                                        //             event
                                        //           )
                                        //     }
                                        //   >
                                        //     {!data.is_attending
                                        //       ? t("Reserve Spot")
                                        //       : t("Cancel Reservation")}
                                        //   </ReservedButton>
                                        // </div>
                                        <div className="buttonContainer" style={{marginTop:"auto"}}> 
                                          {data.event_status !== "over" &&
                                          data.is_attending === 1 &&
                                          !data.event_location &&
                                          moment(convertDateInTimezone(data.start_date)._d) < new Date()
                                            ? (
                                              <a
                                                href={data.event_encrypted_link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ width: "436px", textDecoration: "none" }}
                                              >
                                                <ReservedButton active={true} width="100%">
                                                  {t("Join Event")}
                                                </ReservedButton>
                                              </a>
                                            ) : (
                                              <>
                                                {data.is_attending === 1 && (
                                                  <ReservedButton
                                                    active={1}
                                                    onClick={(event) =>
                                                      this.showCalendar(data.id, data.title, event)
                                                    }
                                                  >
                                                    {t("Add to Calendar")}
                                                  </ReservedButton>
                                                )}
                                        
                                                <ReservedButton
                                                  width={!data.is_attending ? "436px" : undefined}
                                                  active={!data.is_attending}
                                                  onClick={
                                                    isButtonDisabled
                                                      ? null
                                                      : (event) =>
                                                        this.showCalendarAndReserve(
                                                          data.id,
                                                          data.is_attending,
                                                          data.title,
                                                          event
                                                        )
                                                  }
                                                >
                                                  {!data.is_attending
                                                    ? t("Reserve Spot")
                                                    : t("Cancel Reservation")}
                                                </ReservedButton>
                                              </>
                                            )}
                                        </div>
                                        
                                      )}
                                  </div>
                                </CompanyCard>
                                {showCalendar && eventId === data.id && (
                                  <AddInCalendar
                                    show={showCalendar}
                                    closeModal={this.showCalendarData}
                                    hideCalendar={this.hideCalendar}
                                    event={data}
                                    width={"100%"}
                                    margin={"0%"}
                                  />
                                )}
                              </div>
                            ))}
                        </Slider>
                      </SliderContainer>
                    )}
                  </Container>
                </Layout>
              )}
              {wolibaLiveEvents && wolibaLiveEvents.length === 0 ? null : (
                <Layout width margin="0" padding="0 0 15px 0">
                  <div className="headingMain">
                    <div style={{ gap: "12px" }} className="heading">
                      <CompanyWolibaUserEventsIcon />
                      {this.props.t("Woliba Live Events")}
                    </div>
                    {wolibaLiveEvents && wolibaLiveEvents.length > 3 ? (
                      <ViewAllText
                        style={{ gap: "12px" }}
                        onClick={() => this.redirection()}
                      >
                        {`${t("View All")}`} {NewNextArrowIconEventPage()}
                      </ViewAllText>
                    ) : null}
                  </div>
                  {wolibaLiveEvents && wolibaLiveEvents.length > 0 ? (
                    <div className="cardWrapper">
                      {wolibaLiveEvents &&
                        wolibaLiveEvents.slice(0, 3).map((data, index) => (
                          <WolibaCard
                            key={index}
                            width="calc((100% - 50px) / 3)"
                            margin={
                              (index + 1) % 3 === 0
                                ? "0 0 0px 0"
                                : "0 25px 0px 0"
                            }
                          >
                            {data?.coach_details ? (
                              <CoachCard
                                onClick={() =>
                                  this.props.history.push(`/events/${data.id}`)
                                }
                              >
                                <div className="cardWrapper">
                                  <div className="imagecard">
                                    <img
                                      src={`${ImageUrl}/${data?.coach_details?.image}`}
                                    />
                                  </div>
                                  <div className="coach-details">
                                    <div className="title">
                                      {data?.coach_details?.name}
                                    </div>
                                    <div className="info">
                                      {data?.coach_details?.education}
                                    </div>
                                  </div>
                                </div>
                              </CoachCard>
                            ) : (
                              <LazyImage
                                div={"imageCard"}
                                onClick={() =>
                                  this.props.history.push(`/events/${data.id}`)
                                }
                                src={`${ImageUrl}/${data.image}`}
                                alt="category"
                              />
                            )}
                            <div className="bg-opacity"> </div>
                            <div className="detailsCard">
                              <div className="titleCard">
                                <div className="title">{data.title}</div>
                                <div
                                  className="icon"
                                  onClick={(event) =>
                                    this.toggleModal(data.id, event)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <AboutEventIcon/>
                                </div>
                              </div>
                              <div className="time">
                                {moment(
                                  convertDateInTimezone(data && data.start_date)
                                    ._d
                                ).format("MMM DD, hh:mm a")}{" "}
                                ({data.abbreviation}) |{" "}
                                {data.event_location
                                  ? t("Onsite")
                                  : t("Virtual")}
                              </div>
                              {/* {data.is_lunch_and_learn_event === 1 &&
                              data.event_link ? null : (
                                  <ReservedButton
                                    active={!data.is_attending}
                                    width="100%"
                                    onClick={
                                      isButtonDisabled
                                        ? null
                                        : (event) =>
                                          this.handleWolibaLive(
                                            data.id,
                                            data.is_attending,
                                            event
                                          )
                                    }
                                  >
                                    
                                    {!data.is_attending
                                      ? t("Reserve Spot")
                                      : t("Cancel Reservation")}
                                  </ReservedButton>
                                )} */}

                              {data.is_attending === 1 && !data.event_location &&
                                 moment(convertDateInTimezone(data.start_date)._d) < new Date() &&
                                 data.event_status !== "over" ? (
                                  <a
                                    href={data.event_encrypted_link || "#"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ width: "100%", textDecoration: "none" }}
                                  >
                                    <ReservedButton active={true} width="100%">
                                      {t("Join Event")}
                                    </ReservedButton>
                                  </a>
                                ) : (
                                  data.is_lunch_and_learn_event === 1 && data.event_link && data.event_type === 'theme' ? null : (
                                    <ReservedButton
                                      active={!data.is_attending}
                                      width="100%"
                                      onClick={
                                        isButtonDisabled
                                          ? null
                                          : (event) =>
                                            this.handleWolibaLive(
                                              data.id,
                                              data.is_attending,
                                              event
                                            )
                                      }
                                    >
                                      {!data.is_attending
                                        ? t("Reserve Spot")
                                        : t("Cancel Reservation")}
                                    </ReservedButton>
                                  )
                                )}

                            </div>
                            {eventCalendarId === data.id &&
                              showAboutEventModal && (
                              <AboutTheEventModal
                                showModal={showAboutEventModal}
                                onHide={this.toggleModalV2}
                                title={(data && data.title) || ""}
                                body={(data && data.body) || ""}
                              />
                            )}
                            {showCalendar && eventId === data.id && (
                              <AddInCalendar
                                show={showCalendar}
                                closeModal={this.showCalendarData}
                                hideCalendar={this.hideCalendar}
                                event={data}
                                width={"100%"}
                                margin={"0%"}
                              />
                            )}
                          </WolibaCard>
                        ))}
                    </div>
                  ) : (
                    <h1 style={{ paddingLeft: "25px" }}>
                      {this.props.t("No Woliba Live Events")}
                    </h1>
                  )} 
                </Layout>
              )}
              {this.state.eventData?.length > 0 && (
                <RecommendedEvents
                  RecommendedEventData={this.state.eventData}
                  margin="0px 0px 20px 0px"
                  isActivity="1"
                  history={this.props.history} 
                  RecommendedEventDataLoading={this.state.recommendedEventDataLoading}
                  heading={
                    <Heading style={{ margin: "0px" }}>
                      <div style={{marginRight:"16px", display:'flex'}}>{StarIcon("#184A61")}</div>
                      <div>Featured Event of the Month</div>
                    </Heading>
                  }
                  module="user-recommended"
                  hideIcon={true}
                  isButtonWidth={'436px'}
                />
              )}
              
              <HeadingContainer>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clipPath="url(#clip0_652_10405)">
                      <path d="M9 0H5C2.243 0 0 2.243 0 5V7C0 8.103 0.897 9 2 9H9C10.103 9 11 8.103 11 7V2C11 0.897 10.103 0 9 0ZM2 7V5C2 3.346 3.346 2 5 2H9L9.002 7H2ZM22 15H15C13.897 15 13 15.897 13 17V22C13 23.103 13.897 24 15 24H19C21.757 24 24 21.757 24 19V17C24 15.897 23.103 15 22 15ZM22 19C22 20.654 20.654 22 19 22H15V17H22V19ZM19 0H15C13.897 0 13 0.897 13 2V11C13 12.103 13.897 13 15 13H22C23.103 13 24 12.103 24 11V5C24 2.243 21.757 0 19 0ZM15 11V2H19C20.654 2 22 3.346 22 5L22.002 11H15ZM9 11H2C0.897 11 0 11.897 0 13V19C0 21.757 2.243 24 5 24H9C10.103 24 11 23.103 11 22V13C11 11.897 10.103 11 9 11ZM5 22C3.346 22 2 20.654 2 19V13H9L9.002 22H5Z" fill="#184A61"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_652_10405">
                        <rect width="24" height="24" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg> */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "24px",
                      marginLeft: "8px",
                      justifyContent: "center",
                      gap: "12px",
                      marginTop:'15px'
                    }}
                  >
                    <UserEventCatogoriesIcon />
                    <NewTitle
                      fontSize="24px"
                      color="#184A61"
                      style={{
                        marginBottom: "0px",
                        lineHeight: "normal",
                      }}
                    >
                      {t("Event Categories")}
                    </NewTitle>
                  </div>
                </div>
                <div />
              </HeadingContainer>
              <EventPointsWrapper margin >
                {ondemandCategory &&
                  ondemandCategory.length > 0 &&
                  ondemandCategory.map((category, index) => {
                    const IconComponent = categoryIconMap[category.name?.trim()];
                    const bgColor = categoryColorMap[category.name?.trim()] || "red"; 
                    return (
                      category.video_count > 0 && (
                        <CategoryCard
                          isBorderRadius={"4px"}
                          cardPadding={"12px 8px"}
                          key={index}
                          iconColor={bgColor}
                          onClick={() => {
                            this.props.history.push(
                              `/events/ondemand/${category.id}`
                            );
                          }}
                        >
                          <div className="icon-wrapper">
                            {/* <img
                              src={`${ImageUrl}/${category.new_icon}`}
                              alt="category-icon"
                            /> */}
                            {IconComponent && <IconComponent />}
                            
                          </div>

                          <div
                            className="categoryName" style={{fontWeight: 400}}
                            title={this.props.t(category.name)}
                          >
                            {this.props.t(category.name)}
                          </div>
                        </CategoryCard>
                      )
                    );
                  })}
              </EventPointsWrapper>
              <HeadingContainer margin>
                <div />
                {/* {ondemandByIdData?.length > 3&&<div>
                  <ViewAllText
                    onClick={() =>
                      history.push(`/events/ondemand/${selectedCategoryId}`)
                    }
                  >
                    {`${t("View All")}`} {arrowIconDouble()}
                  </ViewAllText>
                </div>} */}
              </HeadingContainer>
              {/* <NewCardContainer topMargin={"topMargin"}>
                {ondemandByIdData.length === 0 ? (
                  <NoComments value>
                    {t("No Ondemand Videos Available For This Category")}
                  </NoComments>
                ) : (
                  ondemandByIdData &&
                  ondemandByIdData.length > 0 &&
                  ondemandByIdData.map(
                    (video, index) =>
                      index <= 5 && (
                        <RecommendEventVideos
                          video={video}
                          key={index}
                          history={history}
                          grid={0}
                          link={link}
                          onEnterMouse={this.onEnterMouse}
                          onLeaveMouse={this.onLeaveMouse}
                          onHover={onHover}
                          count={index}
                        />
                      )
                  )
                )}
              </NewCardContainer> */}
            </div>
          </OndemandContainer>
        ) : null}
      </div>
    );
  }
}

MainEvents.propTypes = {
  history: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  eventResults: PropTypes.array.isRequired,
  loadMoreEvents: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  attendEvent: PropTypes.func.isRequired,
  pastEvents: PropTypes.array.isRequired,
  featuredVideos: PropTypes.array,
  t: PropTypes.func,
  link: PropTypes.string,
  location: PropTypes.object.isRequired,
  webinarCategory: PropTypes.array,
  onEnterMouse: PropTypes.func.isRequired,
  onLeaveMouse: PropTypes.func.isRequired,
  themesHeader: PropTypes.array,
  role: PropTypes.string,
  eventsDetailsPoints: PropTypes.array,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  fetchOnDemandVideosByCatgoryId: PropTypes.func,
  ondemandByIdData: PropTypes.array,
  wolibaEvents: PropTypes.array,
  companyEvents: PropTypes.array,
  fetchEvents: PropTypes.func,
  fetchWolibaEvents: PropTypes.func,
  fetchCompanyEvents: PropTypes.func,
  attendEventLimitUser: PropTypes.func,
  user: PropTypes.object,
  companyInfo: PropTypes.object,
  eventDetail: PropTypes.object,
};

const mapStateToProps = (state) => ({
  eventDetail: state.events.eventDetail,
  themesHeader: state.profileData.themesHeader,
  ondemandCategory: state.events.ondemandCategory,
  ondemandByIdData: state.events.ondemandByIdData,
  // companyId: state?.auth?.user?.companyId || null,
  user: state.profileData.user,
  companyInfo: state.companyDashboard.companyInfo,

});

const mapDispatchToProps = (dispatch) => ({
  fetchOnDemandVideosByCatgoryId: (id) =>
    dispatch(fetchOnDemandVideosByCatgoryId(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MainEvents));

